import { GENDER } from '../../apis/users/users.interfaces';
import { mockUserAction } from '../users/userAction';
import {
  EMPLOYMENT_STATUS,
  TStaffResponse,
} from '../../apis/staff/staff.interfaces';
import { mockDocument } from '../documents/documentMock';

// Indian names
const indianNames = [
  ['Ramesh', 'Agarwal'], ['Priya', 'Sharma'], ['Arjun', 'Kumar'], ['Anjali', 'Patel'], ['Vikram', 'Singh'],
  ['Kavita', 'Reddy'], ['Rajesh', 'Mehta'], ['Meera', 'Iyer'], ['Amit', 'Gupta'], ['Sunita', 'Joshi'],
  ['Suresh', 'Nair'], ['Neha', 'Rao'], ['Karan', 'Desai'], ['Radha', 'Shah'], ['Anil', 'Verma'],
  ['Shreya', 'Agarwal'], ['Manoj', 'Sharma'], ['Divya', 'Patel'], ['Deepak', 'Kumar'], ['Pooja', 'Singh'],
  ['Ravi', 'Reddy'], ['Kiran', 'Mehta'], ['Nisha', 'Gupta'], ['Sandeep', 'Joshi'], ['Uma', 'Iyer'],
  ['Gopal', 'Nair'], ['Lakshmi', 'Rao'], ['Venkat', 'Desai'], ['Sarita', 'Shah'], ['Rohit', 'Verma'],
  ['Aditi', 'Agarwal'], ['Nikhil', 'Sharma'], ['Swati', 'Patel'], ['Kunal', 'Kumar'], ['Richa', 'Singh'],
  ['Varun', 'Reddy'], ['Tanvi', 'Mehta'], ['Harsh', 'Gupta'], ['Isha', 'Joshi'], ['Yash', 'Iyer'],
  ['Aryan', 'Nair'], ['Ananya', 'Rao'], ['Dhruv', 'Desai'], ['Ishita', 'Shah'], ['Rohan', 'Verma'],
  ['Siddharth', 'Agarwal'], ['Tanya', 'Sharma'], ['Vivek', 'Patel'], ['Zara', 'Kumar'], ['Aarav', 'Singh'],
];

const indianCities = ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Hyderabad', 'Pune', 'Ahmedabad', 'Jaipur', 'Surat'];
const indianStates = ['Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'West Bengal', 'Telangana', 'Gujarat', 'Rajasthan'];
const indianPinCodes = ['400001', '110001', '560001', '600001', '700001', '500001', '411001', '380001', '302001', '395001'];

const designations = [
  'Mathematics Teacher', 'English Teacher', 'Science Teacher', 'Physics Teacher', 'Chemistry Teacher',
  'Biology Teacher', 'History Teacher', 'Geography Teacher', 'Computer Science Teacher', 'Hindi Teacher',
  'Sanskrit Teacher', 'Physical Education Teacher', 'Art Teacher', 'Music Teacher', 'Dance Teacher',
  'Principal', 'Vice Principal', 'Head of Department', 'Librarian', 'Lab Assistant',
  'Administrative Staff', 'Accountant', 'Clerk', 'Security Guard', 'Cleaner',
  'Counselor', 'Nurse', 'IT Support', 'Maintenance Staff', 'Transport Coordinator',
];

const departments = [
  'Mathematics', 'English', 'Science', 'Physics', 'Chemistry', 'Biology', 'History', 'Geography',
  'Computer Science', 'Hindi', 'Sanskrit', 'Physical Education', 'Arts', 'Music', 'Dance',
  'Administration', 'Finance', 'IT', 'Library', 'Maintenance', 'Transport', 'Health', 'Counseling',
];

function generateStaff(index: number): TStaffResponse {
  const nameIndex = index % indianNames.length;
  const [firstName, lastName] = indianNames[nameIndex];
  const cityIndex = index % indianCities.length;
  const stateIndex = index % indianStates.length;
  const pinIndex = index % indianPinCodes.length;
  
  const gender = index % 2 === 0 ? GENDER.MALE : GENDER.FEMALE;
  const phoneNumber = `9${String(index).padStart(9, '0')}`.slice(0, 10);
  const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@school.edu`;
  
  const designation = designations[index % designations.length];
  const department = departments[index % departments.length];
  
  const baseDate = new Date('2020-01-01');
  const joiningDate = new Date(baseDate.getTime() + index * 30 * 24 * 60 * 60 * 1000);
  
  const employmentStatus = index % 10 === 0 ? EMPLOYMENT_STATUS.ON_LEAVE :
                           index % 20 === 0 ? EMPLOYMENT_STATUS.INACTIVE :
                           EMPLOYMENT_STATUS.ACTIVE;
  
  return {
    id: `STAFF${String(index + 1).padStart(3, '0')}`,
    basicDetails: {
      firstName,
      middleName: index % 3 === 0 ? 'Kumar' : '',
      lastName,
      gender,
      profile: {
        profilePicture: mockDocument,
        idProof: mockDocument,
        addressProof: mockDocument,
      },
    },
    actions: {
      created: mockUserAction,
    },
    contactDetails: {
      phone: {
        countryCode: '+91',
        phoneNumber,
        isVerified: index % 2 === 0,
      },
      email: {
        email,
        isVerified: true,
      },
      address: {
        address1: `${(index % 100) + 1} ${indianCities[cityIndex]} Street`,
        address2: index % 3 === 0 ? `Apartment ${String.fromCharCode(65 + (index % 5))}-${(index % 10) + 1}` : '',
        city: indianCities[cityIndex],
        state: indianStates[stateIndex],
        country: 'India',
        postalCode: indianPinCodes[pinIndex],
        isCurrent: true,
        description: 'Current residence',
      },
    },
    documents: [],
    designation,
    department,
    joiningDate: {
      ...mockUserAction,
      timestamp: Math.floor(joiningDate.getTime() / 1000),
    },
    employmentStatus,
    email,
  };
}

export const mockStaffList: TStaffResponse[] = Array.from({ length: 60 }, (_, i) => generateStaff(i));
